import { useState, useRef, useEffect, useCallback } from 'react';

export const MessageInput = ({ onSend, disabled, webSearchEnabled, onToggleWebSearch }) => {
  const [input, setInput] = useState('');
  const textareaRef = useRef(null);

  // Auto-resize textarea height
  useEffect(() => {
    const ta = textareaRef.current;
    if (!ta) return;
    ta.style.height = 'auto';
    ta.style.height = Math.min(ta.scrollHeight, 200) + 'px';
  }, [input]);

  const handleSubmit = useCallback(
    (e) => {
      e?.preventDefault();
      const trimmed = input.trim();
      if (trimmed && !disabled) {
        onSend(trimmed);
        setInput('');
        // Reset height
        if (textareaRef.current) {
          textareaRef.current.style.height = 'auto';
        }
      }
    },
    [input, disabled, onSend],
  );

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit();
    }
  };

  return (
    <div className="ChatInputWrapper">
      <div className="ChatInputControls">
        <span className={`SearchToggle-label ${!webSearchEnabled ? 'SearchToggle-label--active' : ''}`}>🎷 Archive Only</span>
        <label className="SearchToggle-label-wrap" title={webSearchEnabled ? 'Switch to archive only' : 'Enable web search'}>
          <input
            type="checkbox"
            className="SearchToggle-input"
            checked={webSearchEnabled}
            onChange={onToggleWebSearch}
          />
          <span className="SearchToggle-track" />
          <span className="SearchToggle-thumb" />
        </label>
        <span className={`SearchToggle-label ${webSearchEnabled ? 'SearchToggle-label--active' : ''}`}>🌐 Web + Archive</span>
      </div>
      <form className="ChatInputBar" onSubmit={handleSubmit}>
        <textarea
          ref={textareaRef}
          className="ChatInput ChatInput-textarea"
          placeholder="Type your message... (Shift+Enter for new line)"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleKeyDown}
          disabled={disabled}
          rows={1}
        />
        <button
          className="ChatSendButton"
          type="submit"
          disabled={disabled || !input.trim()}
        >
          Send
        </button>
      </form>
    </div>
  );
};
